export const SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
export const BOOKING_ALREADY_EXISTS = 'BOOKING_ALREADY_EXISTS';
